import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'settings',
    path: '/settings/:step?',
    component: () => LazyLoadView(import(/* webpackChunkName: "settings" */ '@/views/Settings/Component')),
    exact: true,
    beforeEnter: isAuthenticated,
  },
]
